import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../layoutPages/components/PageTitle';
import { HaveImage, Paragraph } from '../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../layoutPages/defaultSetting';
import { DottedList } from '../../layoutPages/containers/DottedList';
import { MainCard } from '../../layoutPages/components/MainCard';
import { CourseTab } from '../CourseTarget/menuTab';
import { MaterialList } from '../../layoutPages/components/MaterialList';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { introMenuData } from '../../data/intoMenuData';


export function PagePrincipal() {

    const isPc = useMediaQuery('(min-width:600px)');

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <Grid item xs={11} sm={10} >

                <br></br>
                <CourseTab data={introMenuData} />

                <PageTitle title='校長的話 | 學校簡介' size='h3' sx={{ m: 5 }} />

                <Paragraph
                    data={["培僑小學於2000年9月開校，由第一年的只有6班逐步擴展至校舍設計的上限共30 班，現有學生約750人。培僑小學伴隨著教育改革而誕生，為造就「樂善勇敢、終身學習」的人才，努力不懈。在十多年間，我們已成為一間在區內甚受家長歡迎，在業界內薄有名氣的學校。", "培僑小學是一個「人人學習、互相關懷」的地方，「學習」及「關懷」就像空氣一樣，瀰漫在學校的每一個角落。我們擁有一個樂於學習及不斷追求卓越的教師團隊，創校至今一共獲得十項「行政長官卓越教學獎」這個本港最具認受性的教育獎項，獲獎教師累計共35人次，獲獎項目更涵蓋七個不同的範疇，包括藝術教育、體育、中文、英文、數學、課程領導、價值觀教育、德育及公民教育，本校更是全港唯一能在中、英、數三個主科都曾經獲獎的學校。", "一直以來我們都以培育「德智兼備」的下一代為目標，我們透過各類全方位活動、成長課、提倡老師家長以身作則等方式，培養學生養成「自律」、「整潔」、「盡責」、「尊重」及「感恩」這五個好習慣。為裝備學生迎接未來這個瞬息萬變的世代，我們將「自主學習」定為近年學與教發展的關注事項，致力培養學生成為愛自學、懂自學、勤自學的自主學習者，成效顯著。我們亦深信閱讀是終身學習的鑰匙，因此我們十分重視推動閱讀，學校閱讀組老師每年都會為學生舉辦各種別開生面的閱讀活動如「讀書人尋寶夜」、「讀書人與校長共晉午餐」、「閱讀小書窩」等，提高學生對閱讀的興趣，在正規課程方面，中、英文及常識科均有校本閱讀課程，全方位地培養學生閱讀的能力和習慣。", "自2001年加入培僑小學這個「可愛的家」，多年來我與校內數十位同事並肩努力，陪伴着無數學生從小不更事的小童長成善於學習、樂於感恩的青少年，成果得到無數家長及社會各界的認可及認同。未來，我們將繼續秉持「不斷更新變化，追求卓越」的辦學精神，優化我們的課程，引進更多配合時代發展的教學新元素，為培育「德智兼備」的新生代作出更大的貢獻。"]}
                    haveImage={{
                        images: [{ src: "https://www.pkps.edu.hk/img/website/intro/principal.jpg" }],
                        position: "top",
                        imageHeight: "450px",
                    }}
                    sx={{ letterSpacing: 3, lineHeight: 1.5, bgcolor: '#f71', color: "white", p: 3, fontSize: "25px" }}
                />

                <br></br>

                <MainCard src="https://www.pkps.edu.hk/newhtml/educationAwards/galleryImg/2025banner.jpg" sx={{ mb: 3 }} />

                <MainCard src="https://www.pkps.edu.hk/images/14/sch04.jpg?v=2" sx={{ mb: 3 }} />

                <MainCard src="https://www.pkps.edu.hk/images/14/sch02.jpg?v=2" sx={{ mb: 3 }} />

                <MainCard src="https://www.pkps.edu.hk/images/14/sch03.jpg?v=2" sx={{ mb: 3 }} />


            </Grid>
        </Grid>
    )
}
